/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { extractLabelList } from "../core/service/BusinessLogicService"
import { loc } from "../core/utils"
import axios from "axios"
import React, { useEffect, useState } from "react"
import { Form, FormGroup } from "react-bootstrap"
import { Field as FinalFormField, useField, useForm } from "react-final-form"
import AsyncSelect from "react-select/async"

export default function (props) {
  const {
    label,
    hidden,
    name,
    disabled,
    placeholder,
    url,
    token,
    post,
    minLength = 0,
    extractList,
    supplierId,
    setProduct,
    namePrefix,
    defaultValue
  } = props

  const form = useForm()
  const field = useField(namePrefix + ".category")

  const loadOptions = async (value) => {
    return post
      ? value.length >= minLength &&
          axios
            .post(
              url,
              {
                productDescription: value,
                productReference: value,
                supplierId: supplierId,
                productDesignation: value,
                idProductCategory: field.input.value.value != null ? field.input.value.value.toString() : null
              },
              {
                headers: { Authorization: `Bearer ${token}`, Accept: "*/*", "X-Evollis-Force-Supplier-Id": supplierId }
              }
            )
            .then((response) => {
              return extractList(response.data)
            })
      : value.length >= minLength &&
          axios
            .get(url.replace("INPUT_VALUE", value), { headers: { Authorization: `Bearer ${token}`, Accept: "*/*" } })
            .then((response) => {
              if (extractList) {
                return extractList(response.data)
              } else {
                return extractLabelList(response.data)
              }
            })
  }

  if (hidden) {
    return null
  }

  return (
    <FinalFormField name={name} type="text" placeholder={placeholder} className="form-control">
      {({ input, meta }) => {
        const metaError = (meta.error || meta.submitError) && meta.touched
        metaError && console.log(`auto complete ${metaError}`)

        const [defaultOption, setDefaultOption] = useState(null)

        useEffect(() => {
          if (defaultValue) {
            loadOptions(defaultValue).then((options) => {
              if (!options || !Array.isArray(options)) return
              const matched =
                options.find(
                  (opt) => opt.value === defaultValue || opt.label === defaultValue || opt.id === defaultValue
                ) || null

              if (matched) {
                setDefaultOption(matched)
                input.onChange(matched)
              }
            })
          }
        }, [input])

        if (setProduct && input?.value === "") {
          setProduct(null)
        }

        return (
          <FormGroup className="full-width">
            {label && <Form.Label>{label}</Form.Label>}
            <AsyncSelect
              {...input}
              classNamePrefix="react-select"
              className={metaError && "selectfield-error"}
              isDisabled={disabled}
              placeholder={loc`Select...`}
              loadOptions={loadOptions}
              defaultOptions
              isClearable
              autoComplete="off"
              value={input.value || defaultOption}
              // to remove dropdown icone
              components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null, NoOptionsMessage: () => "" }}
              captureMenuScroll={false}
              onChange={(option) => {
                input.onChange(option)
                if (setProduct) setProduct(option)

                // Clear : on vide explicitement les champs dépendants (sinon le prix peut rester affiché)
                if (!option && namePrefix) {
                  form.batch(() => {
                    form.change(namePrefix + ".price", null)
                    form.change(namePrefix + ".brand", null)
                    form.change(namePrefix + ".description", null)
                    form.change(namePrefix + ".family", null)
                    form.change(namePrefix + ".category", null)
                    form.change(namePrefix + ".quantity", "1")
                  })
                }
              }}
            />
            {metaError && <p className="required-message">{meta.error || meta.submitError}</p>}
          </FormGroup>
        )
      }}
    </FinalFormField>
  )
}
